module.exports = __webpack_public_path__ + "static/media/AppIcon-Moon.93783210.png";